export function SVG_SetDash(borderThickness, element) {
  var a = 4 + borderThickness;
  var s = a + ",3";
  element.setAttribute("stroke-dasharray", s);
}
